/**
 * OpenTextInput — reflective, optional textarea.
 */
export default function OpenTextInput({ question, value, onChange }) {
  return (
    <div className="space-y-2">
      {question.helper && (
        <p className="text-xs text-slate-500">{question.helper}</p>
      )}
      <textarea
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        rows={4}
        maxLength={1500}
        placeholder="Take your time…"
        data-testid={`q-${question.id}-textarea`}
        className="w-full rounded-2xl border border-slate-200 bg-white/80 px-4 py-3 text-base text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-purple-300 focus:border-transparent resize-none transition"
      />
      <div className="text-right text-xs text-slate-400">
        {(value || "").length}/1500
      </div>
    </div>
  );
}
